import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a1817db4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sales-report-new-filter-segments" };
const _hoisted_2 = { class: "sales-report-new-filter-segments__selectors" };
const _hoisted_3 = { class: "sales-report-new-filter-segments__wrapper" };
import vSelect from 'vue-select';
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
// components
import SelectedSegmentFilter from './SelectedSegment/FilterSegmentsSelected.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterSegments',
    emits: ["updateSegment"],
    setup(__props, { emit }) {
        // libs
        const store = useStore();
        const segmentOptions = computed(() => store.getters['salesReportNew/getSegments']);
        const hasSomeSegmentApplied = computed(() => store.getters['salesReportNew/getHasSomeSegmentApplied']);
        const segmentSelected = ref('all');
        const sendSelectedSegment = () => store.dispatch('salesReportNew/setSelectedSegement', segmentSelected.value);
        const fetchTable = () => store.dispatch('salesReportNew/setFetchTable');
        const resetSegment = () => store.dispatch('salesReportNew/setResetSegment');
        const fetchIndicators = () => store.dispatch('salesReportNew/setFetchIndicators');
        const hasSegmentSelected = computed(() => segmentSelected.value !== 'all');
        watch(segmentSelected, () => {
            emit('updateSegment', segmentSelected.value);
            if (segmentSelected.value === 'all' && hasSomeSegmentApplied.value) {
                resetSegment();
                fetchTable();
                fetchIndicators();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t('campaign.sales-report.header.label-segment')), 1),
                        _createVNode(_unref(vSelect), {
                            modelValue: segmentSelected.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((segmentSelected).value = $event)),
                            label: "name",
                            clearable: false,
                            class: "w-100",
                            placeholder: _ctx.$t('select'),
                            reduce: item => item.id,
                            options: segmentOptions.value,
                            "onOption:selected": sendSelectedSegment
                        }, {
                            option: _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$tc(name, 1)), 1)
                            ]),
                            "selected-option": _withCtx(({ name }) => [
                                _createTextVNode(_toDisplayString(_ctx.$tc(name, 1)), 1)
                            ]),
                            "open-indicator": _withCtx(({ attributes }) => [
                                _createElementVNode("span", _mergeProps(attributes, { class: "arrow-down" }), null, 16)
                            ]),
                            "no-options": _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('campaign.sales-report.no-results')), 1)
                            ]),
                            _: 1
                        }, 8, ["modelValue", "placeholder", "reduce", "options"])
                    ]),
                    (hasSegmentSelected.value)
                        ? (_openBlock(), _createBlock(SelectedSegmentFilter, { key: 0 }))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
